import React from 'react';
import { Button } from '../ui/Button';
import { TrophyIcon, CheckIcon, ClockIcon, TargetIcon, TimerIcon, Lock, Flame, ShieldIcon, ArrowRightIcon, AlertTriangleIcon, CreditCardIcon } from 'lucide-react';
import { CountdownTimer } from '../ui/CountdownTimer';
export const Pricing: React.FC = () => {
  return <section className="py-16 md:py-20 w-full" data-id="element-215">
      <div className="max-w-4xl mx-auto px-4" data-id="element-216">
        <div className="bg-gradient-to-b from-[#1A1A1A] to-[#0A0A0A] border-2 border-[#E0B84C]/50 rounded-2xl overflow-visible shadow-2xl shadow-[#E0B84C]/10 transform hover:scale-[1.01] transition-all duration-500 relative mt-20 sm:mt-16 pt-8" data-id="element-217">
          <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10" data-id="element-218">
            <div className="bg-[#FF3B30] text-white px-6 py-2 rounded-full font-bold text-sm shadow-lg animate-pulse whitespace-nowrap" data-id="element-219">
              OFERTA POR TIEMPO LIMITADO
            </div>
          </div>
          <div className="p-4 sm:p-8 md:p-12" data-id="element-220">
            <div className="text-center mb-8 md:mb-10" data-id="element-221">
              <div className="inline-flex items-center justify-center p-2 bg-[#0A0A0A] border border-[#E0B84C]/30 rounded-full mb-6 max-w-full overflow-hidden" data-id="element-222">
                <div className="px-2 sm:px-4 py-1 bg-gradient-to-r from-[#E0B84C]/20 to-[#E0B84C]/20 text-[#E0B84C] text-xs sm:text-sm font-medium rounded-full flex items-center" data-id="element-223">
                  <AlertTriangleIcon className="w-3 h-3 sm:w-4 sm:h-4 mr-1 flex-shrink-0" data-id="element-224" />
                  <span className="whitespace-nowrap" data-id="element-225">
                    OFERTA POR TIEMPO LIMITADO
                  </span>
                  <AlertTriangleIcon className="w-3 h-3 sm:w-4 sm:h-4 ml-1 flex-shrink-0" data-id="element-226" />
                </div>
              </div>
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 flex items-center justify-center flex-wrap" data-id="element-227">
                <TargetIcon className="w-6 h-6 sm:w-8 sm:h-8 text-[#E0B84C] mr-2 flex-shrink-0" data-id="element-228" />
                <span className="relative" data-id="element-229">
                  PRECIO DE LANZAMIENTO
                  <span className="absolute -bottom-2 left-0 right-0 h-1 bg-gradient-to-r from-[#E0B84C] to-[#FFD700] rounded-full" data-id="element-230"></span>
                </span>
              </h2>
              <CountdownTimer className="mb-4 mx-auto" small data-id="element-231" />
              <div className="flex items-center justify-center gap-2 sm:gap-4 mb-4 mt-6 flex-wrap" data-id="element-232">
                <div className="relative" data-id="element-233">
                  <span className="text-gray-400 text-xl sm:text-2xl line-through" data-id="element-234">
                    $47 USD
                  </span>
                  <div className="absolute top-1/2 left-0 right-0 h-1 bg-[#FF3B30] transform rotate-[-10deg]" data-id="element-235"></div>
                </div>
                <div className="relative" data-id="element-236">
                  <span className="text-4xl sm:text-5xl md:text-6xl font-bold text-[#FF3B30]" data-id="element-237">
                    $9 USD
                  </span>
                  <div className="absolute -top-3 -right-8 sm:-right-12 bg-[#FF3B30] text-white text-xs px-2 py-1 rounded-full font-bold transform rotate-12" data-id="element-238">
                    -80%
                  </div>
                </div>
              </div>
              <div className="flex items-center justify-center gap-2 text-[#FF3B30] mb-4 animate-pulse" data-id="element-239">
                <ClockIcon className="w-4 h-4 sm:w-5 sm:h-5 text-[#FF3B30] flex-shrink-0" data-id="element-240" />
                <span className="font-medium text-sm sm:text-base" data-id="element-241">
                  El precio subirá en breve
                </span>
              </div>
              <p className="text-base sm:text-lg text-[#CFCFCF] font-medium px-2" data-id="element-242">
                Menos de lo que cuesta una cena rápida… por una{' '}
                <span className="underline decoration-[#E0B84C]" data-id="element-243">
                  mentalidad que dura toda la vida
                </span>
                .
              </p>
            </div>
            <div className="max-w-md mx-auto mb-8 relative" data-id="element-244">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/phW9kH74eaFvhCibhHKBNz/Screenshot_2025-10-02_at_1.43.37_PM.png" alt="Edición Limitada - Póster Premium" className="w-full rounded-lg shadow-lg" data-id="element-245" />
            </div>
            <div className="bg-[#0A0A0A]/60 p-4 sm:p-6 rounded-xl mb-6 sm:mb-8 border border-[#E0B84C]/30" data-id="element-246">
              <h3 className="font-bold text-lg sm:text-xl mb-4 text-center text-[#E0B84C]" data-id="element-247">
                Lo que obtienes hoy:
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4" data-id="element-248">
                <div className="flex items-start gap-2 sm:gap-3" data-id="element-249">
                  <CheckIcon className="w-5 h-5 text-[#22C55E] mt-0.5 flex-shrink-0" data-id="element-250" />
                  <span className="text-sm sm:text-base" data-id="element-251">
                    La travesía completa: de Madeira al mundo{' '}
                    <span className="text-xs text-[#E0B84C] ml-1" data-id="element-252">
                      EXCLUSIVO
                    </span>
                  </span>
                </div>
                <div className="flex items-start gap-2 sm:gap-3" data-id="element-253">
                  <CheckIcon className="w-5 h-5 text-[#22C55E] mt-0.5 flex-shrink-0" data-id="element-254" />
                  <span className="text-sm sm:text-base" data-id="element-255">
                    Mentalidad CR7: disciplina, hambre, constancia{' '}
                    <span className="text-xs text-[#E0B84C] ml-1" data-id="element-256">PREMIUM</span>
                  </span>
                </div>
                <div className="flex items-start gap-2 sm:gap-3" data-id="element-257">
                  <CheckIcon className="w-5 h-5 text-[#22C55E] mt-0.5 flex-shrink-0" data-id="element-258" />
                  <span className="text-sm sm:text-base" data-id="element-259">
                    Momentos inmortales: Manchester, Madrid, Lisboa...
                  </span>
                </div>
                <div className="flex items-start gap-2 sm:gap-3" data-id="element-260">
                  <CheckIcon className="w-5 h-5 text-[#22C55E] mt-0.5 flex-shrink-0" data-id="element-261" />
                  <span className="text-sm sm:text-base" data-id="element-262">
                    9 figuras coleccionables (ilustración original){' '}
                    <span className="text-xs text-[#E0B84C] ml-1" data-id="element-263">
                      LIMITADO
                    </span>
                  </span>
                </div>
                <div className="flex items-start gap-2 sm:gap-3" data-id="element-264">
                  <CheckIcon className="w-5 h-5 text-[#22C55E] mt-0.5 flex-shrink-0" data-id="element-265" />
                  <span className="text-sm sm:text-base" data-id="element-266">
                    Certificado de edición limitada{' '}
                    <span className="text-xs text-[#FF3B30] ml-1" data-id="element-267">
                      NUMERADO
                    </span>
                  </span>
                </div>
                <div className="flex items-start gap-2 sm:gap-3" data-id="element-268">
                  <CheckIcon className="w-5 h-5 text-[#22C55E] mt-0.5 flex-shrink-0" data-id="element-269" />
                  <span className="text-sm sm:text-base" data-id="element-270">
                    Acceso inmediato y multiplataforma
                  </span>
                </div>
                <div className="flex items-start gap-2 sm:gap-3" data-id="element-271">
                  <CheckIcon className="w-5 h-5 text-[#22C55E] mt-0.5 flex-shrink-0" data-id="element-272" />
                  <span className="text-sm sm:text-base" data-id="element-273">
                    Póster 4K Premium{' '}
                    <span className="text-xs text-[#E0B84C] ml-1" data-id="element-274">BONUS</span>
                  </span>
                </div>
                <div className="flex items-start gap-2 sm:gap-3" data-id="element-275">
                  <CheckIcon className="w-5 h-5 text-[#22C55E] mt-0.5 flex-shrink-0" data-id="element-276" />
                  <span className="text-sm sm:text-base" data-id="element-277">
                    Plantilla "Rutina 110%"{' '}
                    <span className="text-xs text-[#E0B84C] ml-1" data-id="element-278">BONUS</span>
                  </span>
                </div>
                <div className="flex items-start gap-2 sm:gap-3 md:col-span-2" data-id="element-279">
                  <CheckIcon className="w-5 h-5 text-[#22C55E] mt-0.5 flex-shrink-0" data-id="element-280" />
                  <span className="text-sm sm:text-base" data-id="element-281">
                    Pack de fondos (Móvil + PC){' '}
                    <span className="text-xs text-[#E0B84C] ml-1" data-id="element-282">BONUS</span>
                  </span>
                </div>
              </div>
            </div>
            <div className="text-center" data-id="element-283">
              <div className="mb-6" data-id="element-284">
                <div className="inline-block px-3 sm:px-4 py-1 sm:py-2 bg-[#E0B84C]/10 border border-[#E0B84C]/30 rounded-full text-[#E0B84C] text-xs sm:text-sm mb-4 flex items-center animate-pulse" data-id="element-285">
                  <TimerIcon className="w-3 h-3 sm:w-4 sm:h-4 mr-1 flex-shrink-0" data-id="element-286" />
                  <span className="whitespace-nowrap" data-id="element-287">
                    Solo quedan pocas copias en esta tirada
                  </span>
                </div>
                <p className="text-sm sm:text-base text-[#CFCFCF] font-medium px-2" data-id="element-288">
                  Haz lo que haría un verdadero fan. Descarga tu edición
                  limitada{' '}
                  <span className="underline decoration-[#E0B84C]" data-id="element-289">ahora</span>.
                  Antes de que otro lo haga.{' '}
                  <span className="text-[#FF3B30]" data-id="element-290">
                    Antes de que desaparezcan.
                  </span>
                </p>
              </div>
              <Button className="text-sm sm:text-lg px-4 sm:px-8 py-3 sm:py-4 w-full sm:max-w-[90%] md:w-auto flex items-center justify-center gap-2 shadow-lg shadow-[#22C55E]/20 transform hover:scale-105 transition-all duration-300 mx-auto" href="https://store.collectiondigital.vip/cart/45861496684706:1" id="cta-download-pricing" trackClick={true} data-id="element-291">
                <TrophyIcon className="w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0" data-id="element-292" />
                <span className="flex items-center gap-1 whitespace-nowrap text-xs sm:text-base" data-id="element-293">
                  <Flame className="w-3 h-3 sm:w-5 sm:h-5 text-yellow-300 animate-pulse flex-shrink-0" data-id="element-294" />{' '}
                  OBTENER AHORA · SOLO $9{' '}
                  <Flame className="w-3 h-3 sm:w-5 sm:h-5 text-yellow-300 animate-pulse flex-shrink-0" data-id="element-295" />
                </span>
                <ArrowRightIcon className="w-4 h-4 sm:w-5 sm:h-5 ml-1 flex-shrink-0" data-id="element-296" />
              </Button>
              <div className="mt-4 flex flex-col items-center" data-id="element-297">
                <div className="text-xs sm:text-sm text-gray-400 flex flex-wrap items-center justify-center gap-1 sm:gap-2 mb-2 px-2" data-id="element-298">
                  <Lock className="w-3 h-3 sm:w-4 sm:h-4 text-[#E0B84C] flex-shrink-0" data-id="element-299" />
                  <span data-id="element-300">Entrega instantánea</span> •
                  <span data-id="element-301">Compra 100% segura</span> •
                  <span data-id="element-302">Acceso de por vida</span>
                </div>
                <div className="flex items-center justify-center gap-2" data-id="element-303">
                  <CreditCardIcon className="w-3 h-3 sm:w-4 sm:h-4 text-gray-400 flex-shrink-0" data-id="element-304" />
                  <span className="text-gray-400 text-xs" data-id="element-305">
                    Aceptamos todas las tarjetas y PayPal
                  </span>
                </div>
              </div>
            </div>
            <div className="mt-6 sm:mt-8 p-3 sm:p-4 border border-[#22C55E]/30 rounded-lg bg-[#22C55E]/5 flex items-center" data-id="element-306">
              <ShieldIcon className="w-4 h-4 sm:w-6 sm:h-6 text-[#22C55E] mr-2 sm:mr-3 flex-shrink-0" data-id="element-307" />
              <p className="text-xs sm:text-sm text-[#22C55E]" data-id="element-308">
                <span className="font-bold" data-id="element-309">100% Garantizado:</span> Tu
                satisfacción es nuestra prioridad. Soporte prioritario y
                experiencia premium garantizada.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-6 text-xs text-center text-gray-500 max-w-3xl mx-auto px-4" data-id="element-310">
        <p data-id="element-311">
          ⚠️ Las imágenes utilizadas son ilustraciones artísticas estilizadas,
          no fotografías oficiales. Arte conceptual creado por fans.
        </p>
      </div>
    </section>;
};